import styled from '@emotion/styled';

export const STitle = styled.div`
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  padding-left: 16px;

  color: rgba(0, 0, 0, 0.85);
`;

export const SHeader = styled.div`
  margin-top: 24px;
`;

export const SContent = styled.div`
  margin-top: 24px;
  background-color: white;
  flex-grow: 1;
`;

export const SContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const STabs = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  .ant-tabs {
    .ant-tabs-nav {
      margin: 0;
    }
    .ant-tabs-tab {
      padding: 17px 0;

      .ant-tabs-tab-btn {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
`;
